import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

// Components
import { InputField } from "../../../../Components/formElements/InputField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { getMaterialList } from "../../../../redux/feature/profit_ledger/profitLedgerSlice";

const MaterialHBModalV2 = React.forwardRef((props, ref) => {
  // const message = {
  //   VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  //   VALID_MAIL_ID: "Please enter a valid email address.",
  //   VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  //   VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  //   VALID_ALTERNATE_CONTACT_NUMBER:
  //     "Please enter a valid alternate contact number.",
  //   VALID_PURPOSE_JUSTIFICATION:
  //     "Please ensure the justification is under 500 characters.",
  //   VALID_POSTAL_CODE:
  //     "Enter a 6-character postal code with uppercase letters and numbers only",
  //   VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  //   VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  //   EXIStS_MAIL_ID: "Email already exists",
  //   EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  //   EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  //   EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  //   FILL_REQUIRED_FIELD: "Please fill the required field",
  //   ALTERNATE_MAIL_ID: "Email ID is same",
  //   ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  // };

  let materialNr = useSelector(
    (state) => state?.customerV1?.material?.materialNr,
  );

  const dispatch = useDispatch();

  const [formInputs, setFormInputs] = useState({
    materialAttachments: "",
    materialImage: "",
    buildingType: [],
    activeInactive: true,
  });

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  /*   const units = [
    { id: 1, name: "UNIT", code: "UN", description: "UNIT" },
    { id: 2, name: "PCS", code: "PC", description: "PCS" },
    { id: 3, name: "ROLL", code: "RL", description: "ROLL" },
    { id: 4, name: "SELECT", code: "SE", description: "SELECT" },
    { id: 5, name: "KG", code: "KG", description: "KG" },
    { id: 6, name: "BOX", code: "BX", description: "BOX" },
    { id: 7, name: "PKT", code: "PK", description: "PKT" },
    { id: 8, name: "PAIR", code: "PR", description: "PAIR" },
    { id: 9, name: "PACKET", code: "PA", description: "PACKET" },
    { id: 10, name: "SET", code: "ST", description: "SET" },
    { id: 11, name: "SHEET", code: "SH", description: "SHEET" },
    { id: 12, name: "METER", code: "MT", description: "METER" },
    { id: 13, name: "CONE", code: "CN", description: "CONE" },
    { id: 14, name: "U", code: "U", description: "U" },
    { id: 15, name: "FEET", code: "FT", description: "FEET" },
    { id: 16, name: "MTR", code: "MT", description: "MTR" },
    { id: 17, name: "PCS", code: "PC", description: "PCS" },
    { id: 18, name: "KG", code: "KG", description: "KG" },
    { id: 19, name: "LTR", code: "LT", description: "LTR" },
    { id: 20, name: "SQINCH", code: "SI", description: "SQINCH" },
    { id: 21, name: "PAIRS", code: "PR", description: "PAIRS" },
    { id: 22, name: "SQFT", code: "SF", description: "SQFT" },
    { id: 23, name: "LTR", code: "LT", description: "LTR" },
    { id: 24, name: "NULL", code: "NA", description: "NULL" },
    { id: 25, name: "STICK", code: "SK", description: "STICK" },
    { id: 26, name: "RIM", code: "RM", description: "RIM" },
  ]; */

  /*  const materialGroups = [
    { id: 1, name: "WALKING AIDS", code: "WA", description: "WALKING AIDS" },
    { id: 2, name: "WALKING STICK", code: "WS", description: "WALKING STICK" },
    { id: 3, name: "CRUTCHES", code: "CR", description: "CRUTCHES" },
    { id: 4, name: "WALKER", code: "WK", description: "WALKER" },
    { id: 5, name: "ROLLATORS", code: "RL", description: "ROLLATORS" },

    {
      id: 6,
      name: "RESPIRATORY CARE",
      code: "RC",
      description: "RESPIRATORY CARE",
    },
    { id: 7, name: "CPAP MACHINE", code: "CPAP", description: "CPAP MACHINE" },
    { id: 8, name: "BIPAP", code: "BIPAP", description: "BIPAP" },
    { id: 9, name: "VENTILATORS", code: "VENT", description: "VENTILATORS" },
    {
      id: 10,
      name: "OXYGEN CYLINDER",
      code: "OC",
      description: "OXYGEN CYLINDER",
    },
    {
      id: 11,
      name: "PULSE OXIMETER",
      code: "PO",
      description: "PULSE OXIMETER",
    },
    {
      id: 12,
      name: "OXYGEN CONCENTRATOR",
      code: "OXC",
      description: "OXYGEN CONCENTRATOR",
    },
    { id: 13, name: "NEBULIZER", code: "NEB", description: "NEBULIZER" },

    {
      id: 14,
      name: "PATIENT TRANSFER",
      code: "PT",
      description: "PATIENT TRANSFER",
    },
    { id: 15, name: "WHEEL CHAIRS", code: "WC", description: "WHEEL CHAIRS" },
    { id: 16, name: "STAIR CHAIR", code: "SC", description: "STAIR CHAIR" },
    { id: 17, name: "PATIENT LIFT", code: "PL", description: "PATIENT LIFT" },
    { id: 18, name: "STRETCHER", code: "STR", description: "STRETCHER" },

    { id: 19, name: "AIR MATTRESS", code: "AM", description: "AIR MATTRESS" },
    {
      id: 20,
      name: "TUBE AIR MATTRESS",
      code: "TAM",
      description: "TUBE AIR MATTRESS",
    },
    {
      id: 21,
      name: "BUBBLE AIR MATTRESS",
      code: "BAM",
      description: "BUBBLE AIR MATTRESS",
    },
    { id: 22, name: "WATER BED", code: "WB", description: "WATER BED" },

    {
      id: 23,
      name: "PATIENT CLOTHING",
      code: "PC",
      description: "PATIENT CLOTHING",
    },
    { id: 24, name: "GOWN", code: "GWN", description: "GOWN" },
    { id: 25, name: "LOWER", code: "LWR", description: "LOWER" },
    { id: 26, name: "SUIT", code: "SUT", description: "SUIT" },

    { id: 27, name: "BACK CARE", code: "BC", description: "BACK CARE" },
    { id: 28, name: "BACKREST", code: "BR", description: "BACKREST" },
    { id: 29, name: "LS BELT", code: "LSB", description: "LS BELT" },
    { id: 30, name: "TAYLOR BRACE", code: "TB", description: "TAYLOR BRACE" },

    { id: 31, name: "NECK CARE", code: "NC", description: "NECK CARE" },
    { id: 32, name: "NECKREST", code: "NR", description: "NECKREST" },
    {
      id: 33,
      name: "CERVICAL PILLOW",
      code: "CP",
      description: "CERVICAL PILLOW",
    },
    {
      id: 34,
      name: "CERVICAL COLLAR",
      code: "CC",
      description: "CERVICAL COLLAR",
    },
    {
      id: 35,
      name: "PHILADELPHIA COLLAR",
      code: "PCO",
      description: "PHILADELPHIA COLLAR",
    },

    { id: 36, name: "MOTHER CARE", code: "MC", description: "MOTHER CARE" },
    {
      id: 37,
      name: "MATERNITY BELT",
      code: "MB",
      description: "MATERNITY BELT",
    },
    { id: 38, name: "BREAST PUMP", code: "BP", description: "BREAST PUMP" },
    { id: 39, name: "BABY BLANKET", code: "BB", description: "BABY BLANKET" },
    {
      id: 40,
      name: "BREATHABLE MAC SHEET",
      code: "BMS",
      description: "BREATHABLE MAC SHEET",
    },
    {
      id: 41,
      name: "SILICONE BABY PRODUCT",
      code: "SBP",
      description: "SILICONE BABY PRODUCT",
    },

    { id: 42, name: "KNEE CARE", code: "KC", description: "KNEE CARE" },
    { id: 43, name: "KNEE CAP", code: "KCAP", description: "KNEE CAP" },
    {
      id: 44,
      name: "HINGED KNEE BRACE",
      code: "HKB",
      description: "HINGED KNEE BRACE",
    },
    {
      id: 45,
      name: "KNEE IMMOBILIZER",
      code: "KI",
      description: "KNEE IMMOBILIZER",
    },
    { id: 46, name: "ROM BRACE", code: "ROM", description: "ROM BRACE" },

    { id: 47, name: "FOOT CARE", code: "FC", description: "FOOT CARE" },
    { id: 48, name: "TOE CARE", code: "TC", description: "TOE CARE" },
    { id: 49, name: "FOOT WEAR", code: "FW", description: "FOOT WEAR" },
    { id: 50, name: "HEALTH SOCKS", code: "HS", description: "HEALTH SOCKS" },
    {
      id: 51,
      name: "SILICONE HEEL PRODUCTS",
      code: "SHP",
      description: "SILICONE HEEL PRODUCTS",
    },
    {
      id: 52,
      name: "SILICONE INSOLES",
      code: "SI",
      description: "SILICONE INSOLES",
    },

    { id: 53, name: "SCAR CARE", code: "SCAR", description: "SCAR CARE" },
  ]; */
  // eslint-disable-next-line
  const [validation, setValidation] = useState({});

  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);

  const [getShowFailureModal, setShowFailureModal] = useState();

  const [disabled, setDisabled] = useState("");

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [materialMode, setMaterialMode] = useState(true);

  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line
  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line
  const [getCompanyCode, setCompanyCode] = useState([]);

  const getMasterDataFunc = async () => {
    let obj3 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setMaterialMode(false);
    } else if (props?.show === "EDIT") {
      setMaterialMode(false);
    } else if (props?.show === "DETAILS") {
      setMaterialMode(true);
    } else {
      setMaterialMode(true);
    }
  }, [props?.show]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({
        materialAttachments: "",
        materialImage: "",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        average: "",
        quntity: "",
        pieceMeasure: "",
        unit: "",
        unitWeight: "",
        unitPrice: "",
        unitWeightModifier: "",
        unitPriceModifier: "",
        surfacePaintArea: "",
        remarks: "",
        weightPice: "",
        weightTotal: "",
        bookPrice: "",
        bookTotalPrice: "",
      });
    }
  }, [props?.show]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  // const onInputChange = ({ target: { name, value } }) => {
  //   const errors = {};
  //   setFormInputs((prev) => {
  //     const formattedValue =
  //       name === "materialCode" || name === "materialDescription"
  //         ? value.toUpperCase()
  //         : value;

  //     const updated = { ...prev, [name]: formattedValue };

  //     // Parse values to numbers (default to 0 if empty/invalid)
  //     const pieceMeasure = parseFloat(updated.pieceMeasure) || 0;
  //     const unitWeight = parseFloat(updated.unitWeight) || 0;
  //     const unitWeightModifier = parseFloat(updated.unitWeightModifier) || 0;
  //     const unitPrice = parseFloat(updated.unitPrice) || 0;
  //     const unitPriceModifier = parseFloat(updated.unitPriceModifier) || 0;
  //     const quantity = parseFloat(updated.quntity) || 0;

  //     // Helper for rounding to 3 decimals
  //     const round3 = (num) => Math.round(num * 1000) / 1000;

  //     // Calculations (rounded)
  //     const weightPice = round3(pieceMeasure * unitWeight * unitWeightModifier);
  //     const weightTotal = round3(weightPice * quantity);
  //     const bookPrice = round3(pieceMeasure * unitPrice * unitPriceModifier);
  //     const bookTotalPrice = round3(bookPrice * quantity);

  //     return {
  //       ...updated,
  //       weightPice,
  //       weightTotal,
  //       bookPrice,
  //       bookTotalPrice,
  //     };
  //   });

  //   setValidation((prev) => ({
  //     ...prev,
  //     [name]: errors[name] || "",
  //   }));
  // };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  useEffect(() => {
    if ((props?.show === "EDIT" || props?.show === "DETAILS") && materialNr) {
      setLoading(true); // start loading
      let obj = {
        queryName: "Get_MATERIAL_DETAIL",
        documentNumber: materialNr,
      };
      ItemService.generateCustomerQueryHb(obj)
        .then((res) => {
          if (res?.data?.length) {
            setFormInputs(res.data[0]);
          }
        })
        .catch(() => {
          toast.error("Failed to fetch material details!");
        })
        .finally(() => {
          setLoading(false); // stop loading
        });
    }
  }, [props?.show, materialNr]);

  const handleSubmit = async () => {
    // let requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateRequired(formInputs.materialCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    //-------------------------------------------

    // if (!validateRequired(formInputs.materialDescription)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialDescription: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateRequired(formInputs.materialDescription)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialDescription: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    //-------------------
    // if (!validateRequired(formInputs.materialGroup)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialGroup: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unit)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unit: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unitWeight)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitWeight: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unitPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unitWeightModifier)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitWeightModifier: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unitPriceModifier)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitPriceModifier: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.surfacePaintArea)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     surfacePaintArea: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.remarks)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     remarks: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    let obj = {
      data: {
        ...formInputs,
        orderPriceUnit: parseFloat(formInputs?.unitPrice),
        orderUnitOfMeasure: formInputs?.unit,
        uOM: formInputs?.unit,
      },
    };

    setDisabled(true);
    // await ItemService.addMaterialHb(obj).then((item) => {
    await ItemService.addMaterial(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "User Invited successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
        });
        let obj = {
          queryName: "Get_MATERIAL_LIST",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  //handle Update
  const handleUpdate = async () => {
    let thickNessInMeter = parseFloat(formInputs?.thickNess) / 1000 || 0;
    let webPlateXInMeter = parseFloat(formInputs?.webPlateX) / 1000 || 0;
    let webPlateYInMeter = parseFloat(formInputs?.webPlateY) / 1000 || 0;
    let avg = parseFloat(webPlateXInMeter + webPlateYInMeter) / 2 || 0;

    // let obj = {
    //   ...formInputs,
    //   thickNessInMeter,
    //   webPlateXInMeter,
    //   webPlateYInMeter,
    //   avg,
    // };

    const { _id, ...rest } = {
      ...formInputs,
      thickNessInMeter,
      webPlateXInMeter,
      webPlateYInMeter,
      avg,
    };

    setDisabled(true);
    await ItemService.updateMaterial(rest).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "User Invited successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
        });

        props.refreshMaterialList({
          queryName: "Get_ALL_Materials",
          page: 1,
          per_page: 10,
        });
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  /*  web plate */

  // const [getBuildingType, setBuildingType] = useState();
  // console.log(">>getBuildingType", getBuildingType);
  //buildingTypeArray in handle save
  // const buildingTypeArray =
  //   getBuildingType?.buildingType
  //     ?.filter((building) => building?.code) // Filter out undefined/null codes
  //     ?.map((building) => building.code) // Extract codes
  //     ?.sort((a, b) => {
  //       // Custom sort to get ["MG", "CS", "MS"]
  //       const order = { MG: 1, CS: 2, MS: 3 };
  //       return (order[a] || 999) - (order[b] || 999);
  //     }) || [];

  // console.log(">>buildingTypeArray", buildingTypeArray); // Output: ["MG", "CS", "MS"]

  useEffect(() => {
    if (getDropdownData?.textField === "materialGroup") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        materialGroup: getDropdownData?.name,
        materialGroupCode: getDropdownData?.code,
        materialGroupDesc: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "unit") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    }
  }, [getDropdownData]);

  // ✅ 2️⃣ Recompute materialDescription every time webplate changes
  // useEffect(() => {
  //   if (!webplate?.materialGroup) return;

  //   setFormInputs((prev) => {
  //     const { thickNess, webPlateX, webPlateY } = prev;

  //     let desc = webplate.materialGroup;

  //     if (thickNess) desc += ` ${thickNess}MM`;

  //     if (webPlateX && webPlateY) {
  //       desc += ` (${webPlateX}-${webPlateY})`;
  //     } else if (webPlateX) {
  //       desc += ` (${webPlateX})`;
  //     } else if (webPlateY) {
  //       desc += ` (${webPlateY})`;
  //     }

  //     return { ...prev, materialDescription: desc };
  //   });
  // }, [webplate]); //

  //validation
  // const handleCheckValidation = async ({ target: { name, value } }) => {
  //   if (!value) return false;

  //   let obj = {};
  //   let queryName = "";

  //   // Choose the correct query based on field name
  //   if (name === "materialCode") {
  //     queryName = "Check_Material_Duplication";
  //     obj = { queryName, materialCode: value };
  //   } else {
  //     return false;
  //   }

  //   try {
  //     const item = await ItemService.generateCustomerQueryHb(obj);
  //     let errorMsg = "";

  //     if (
  //       item?.status === 200 &&
  //       item?.data?.length > 0 &&
  //       item.data[0].isItDuplicate === "true"
  //     ) {
  //       errorMsg = `This ${
  //         name === "materialCode" ? "Material" : "Material"
  //       } Code already exists.`;
  //     }

  //     // Update validation state
  //     setValidation((prev) => ({
  //       ...prev,
  //       [name]: errorMsg,
  //     }));

  //     return errorMsg ? true : false;
  //   } catch (err) {
  //     console.error("Error during validation:", err);
  //     setValidation((prev) => ({
  //       ...prev,
  //       [name]: "Unable to validate. Please try again.",
  //     }));
  //     return true;
  //   }
  // };

  useEffect(() => {
    if (props?.data) {
      setFormInputs(props?.data);
    }
    getMasterDataFunc();
  }, [props]);

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.show === "CREATE"
              ? "Create Material/Product"
              : props?.show === "DETAILS"
                ? "Material/Product Detail"
                : props?.show === "EDIT"
                  ? "Edit Material/Product"
                  : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {/* accordin1 */}
              <div
                xs={12}
                md={6}
                lg={6}
                className="commLeftRightPadding d-flex align-items-end mb-4"
              >
                {/*      {props?.show !== "DETAILS" && (
                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <FileUploadComponent
                      id="materialImage"
                      name="materialImage"
                      label="Material Image"
                      allowedTypes={["image/png", "image/jpeg"]} // ✅ only images
                      multiple={false} // ✅ only single file selection
                      required={true}
                      onSuccessUpload={onSuccessUploadDocumentType}
                      value={formInputs?.materialImage || ""}
                    />
                  </Col>
                )} */}
                {/*    <Col
                  xs={12}
                  md={4}
                  lg={4}
                  className="commLeftRightPadding d-flex justify-content-center align-items-center"
                >
                  <div
                    style={{ width: "100%" }}
                    className="d-flex justify-content-center align-items-center"
                  >                  
                    <ShowUploadImageV2 fileid={formInputs?.materialImage} />
                  </div>
                </Col> */}
              </div>
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Basic Information</span>
                        <span className="subHeaderTitle">
                          Basic Infromation
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Material Code"
                            id="materialCode"
                            name="materialCode"
                            type="text"
                            value={formInputs?.materialCode || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.materialCode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Material Description"
                            id="materialDescription"
                            name="materialDescription"
                            type="text"
                            value={formInputs?.materialDescription || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.materialDescription}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Material Group"
                            id="material"
                            name="material"
                            type="text"
                            value={formInputs?.material || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.material}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Material"
                            id="materialGroup"
                            name="materialGroup"
                            type="text"
                            value={formInputs?.materialGroup || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.materialGroup}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit of Mesure"
                            id="uOM"
                            name="uOM"
                            type="text"
                            value={formInputs?.uOM || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.uOM}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Per Bag Box"
                            type="number"
                            id="perBagBox"
                            name="perBagBox"
                            value={formInputs?.perBagBox || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.perBagBox}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit"
                            id="unitIn"
                            name="unitIn"
                            type="text"
                            value={formInputs?.unitIn || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitIn}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="CGST"
                            id="cgst"
                            name="cgst"
                            type="number"
                            value={formInputs?.cgst || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.cgst}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="SGST"
                            id="sgst"
                            name="sgst"
                            type="number"
                            value={formInputs?.sgst || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.sgst}
                          />
                        </Col>

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Company Code"
                            extraLabel="SAP Company Code"
                            placeholder=""
                            data={getCompanyCode}
                            id="companyCode"
                            iconClassName="dropdownIcon"
                            name="companyCode"
                            code="companyCodeCode"
                            description="companyCodeDesc"
                            disabled={materialMode}
                            setValue={formInputs?.companyCode || []}
                            getvalue={setDropdownData}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="HSN Code"
                            id="hsnCode"
                            name="hsnCode"
                            type="text"
                            value={formInputs?.hsnCode || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.hsnCode}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Quantity"
                            id="purchaseQuantity"
                            name="purchaseQuantity"
                            type="text"
                            value={formInputs?.purchaseQuantity || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.purchaseQuantity}
                          />
                        </Col> */}

                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit"
                            id="unit"
                            name="unit"
                            type="text"
                            value={formInputs?.unit || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unit}
                          />
                        </Col> */}
                        {/*  <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="Unit"
                            placeholder=""
                            data={units}
                            name="unit"
                            code="unitCode"
                            description="unitDesc"
                            setValue={formInputs?.unit || ""}
                            getvalue={setDropdownData}
                            disabled={materialMode}
                          />
                        </Col> */}

                        {/*     <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit Price"
                            id="unitPrice"
                            name="unitPrice"
                            type="text"
                            value={formInputs?.unitPrice || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitPrice}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit weight Modifier"
                            id="unitWeightModifier"
                            name="unitWeightModifier"
                            type="text"
                            value={formInputs?.unitWeightModifier || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitWeightModifier}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Unit Price Modifier"
                            id="unitPriceModifier"
                            name="unitPriceModifier"
                            type="text"
                            value={formInputs?.unitPriceModifier || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.unitPriceModifier}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            placeholder=""
                            className="inputBox"
                            label="Surface/Paint Area"
                            id="surfacePaintArea"
                            name="surfacePaintArea"
                            type="number"
                            value={formInputs?.surfacePaintArea || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            // error={validation?.surfacePaintArea}
                          />
                        </Col> */}
                        {/*   <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            placeholder=""
                            className="inputBox"
                            label="Remarks"
                            id="remarks"
                            name="remarks"
                            value={formInputs?.remarks || ""}
                            onChange={onInputChange}
                            disabled={materialMode}
                            error={validation?.remarks}
                          />
                        </Col> */}

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="materialAttachments"
                            name="materialAttachments"
                            label="Material Attachments"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.materialAttachments || ""}
                            error={validation?.materialAttachments}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commLeftRightPadding"
                        >
                          {formInputs?.materialAttachments && (
                            // <ShowUploadImage  fileid= {formInputs?.materialAttachments}/>
                            // <ShowUploadImage fileid={formInputs?.materialAttachment || formInputs?.materialAttachments} />

                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.materialAttachments)
                              }
                            />
                          )}
                        </Col>

                        {/* <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Pice"
                        id="weightPice"
                        name="weightPice"
                        type="text"
                        value={formInputs.weightPice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Weight Total"
                        id="weightTotal"
                        name="weightTotal"
                        type="text"
                        value={formInputs.weightTotal || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Price"
                        id="bookPrice"
                        name="bookPrice"
                        type="text"
                        value={formInputs.bookPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                      <InputField
                        placeholder=""
                        className="inputBox"
                        label="Book Total Price"
                        id="bookTotalPrice"
                        name="bookTotalPrice"
                        type="text"
                        value={formInputs.bookTotalPrice || ""}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          <div>
                            <label
                              className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                              htmlFor="activeInactive"
                            >
                              Active/Inactive
                            </label>
                          </div>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input custom-switch"
                              type="checkbox"
                              role="switch"
                              name="activeInactive"
                              id="activeInactive"
                              checked={formInputs?.activeInactive || false}
                              disabled={materialMode}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  activeInactive: e.target.checked,
                                }))
                              }
                              // disabled={editMode}
                            />
                            <span className="ms-2">
                              {formInputs?.activeInactive
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </div>
                        </Col>
                        <Col xs={12} md={12} lg={12}></Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {props.show !== "DETAILS" && (
                <div className="space-y-4">
                  <Row className="justify-end">
                    <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                      <button
                        type="button"
                        onClick={() => props.onHide()}
                        className="btn btn-danger mt-4 w-full justify-center rounded-md"
                      >
                        Cancel
                      </button>
                    </Col>
                    {props.show === "CREATE" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleSubmit}
                          disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Save
                        </button>
                      </Col>
                    )}
                    {props.show === "EDIT" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleUpdate}
                          disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Update
                        </button>
                      </Col>
                    )}
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className="commLeftRightPadding"
                    >
                      {/* <p className="errorMsg"> {errorMsg} </p> */}
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={failureModalData}
        requiredfields={getErrorFields}
      />
    </>
  );
});

export default MaterialHBModalV2;
